// Cart recommendations
class ProductRecommendationsCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
   this.init();
  }

  updateRecommendations(callback) {
    this.init().then((isUpdate) => {
      if (typeof callback === 'function') {
        const result = callback();
        console.log('Update callback result:', result);
      }
    });
  }

  init() {
    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {        
        console.count();
        const html = document.createElement('div');
        html.innerHTML = text;
        this.style.height = `${this.offsetHeight}px`
        const recommendations = html.querySelector('product-recommendations-cart');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initializeSwiper();
          this.style.height = 'auto';
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  initializeSwiper() {
    new Swiper('.swiper-container', {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 30,
      breakpoints: {
        300: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        400: {
          slidesPerView: 1.3,
          spaceBetween: 30,
        }
      }
    });
  }
}

customElements.define('product-recommendations-cart', ProductRecommendationsCart);

class ProductQuantity extends HTMLElement
{
    constructor()
    {
        super();

        this.options = {
            min: 1,
            max: -1,
            step: 1
        };
        
        if(this.dataset.min){
            let minOption = parseInt(this.dataset.min);
            if(minOption > 0){
                this.options.min = minOption;
            }
        }

        if(this.dataset.max){
            let maxOption = parseInt(this.dataset.max);
            if(maxOption > 0){
                this.options.max = maxOption;
            }
        }

        if(this.dataset.step){
            let stepOption = parseInt(this.dataset.step);
            if(stepOption > 0){
                this.options.step = stepOption;
            }
        }

        this.incrementBtn = this.querySelector('[data-qty-plus]');
        this.decrementBtn = this.querySelector('[data-qty-minus]');
        this.inputField = this.querySelector('[data-qty-input]');

        if(this.incrementBtn){
            this.incrementBtn.addEventListener('click', this.incrementEvent.bind(this), false);
        }

        if(this.decrementBtn){
            this.decrementBtn.addEventListener('click', this.decrementEvent.bind(this), false);
        }

        this.value = this.inputField ? parseInt(this.inputField.value) : 1;

        this.querySelector('input[name="quantity"]')?.addEventListener('keyup', e => {
            let keyCode = e.keyCode || e.charCode;
            if(keyCode == 8 || keyCode == 46){
                return false;
            }
            let qty = parseInt(e.target.value);
            qty = !isNaN(qty) ? qty : 1;
            qty = qty > 0 ? qty : 0;
   
            e.target.value = qty;
        });
    }

    incrementEvent(e)
    {
        e.preventDefault();
        if(!this.inputField){
            return;
        }

        this.value = parseInt(this.inputField.value);

        if(this.options.max > 0 && (this.value + 1) > this.options.max){
            this.value = this.options.max;
        }else{
            this.value++;
        }

        this.inputField.value = this.value;

        this.inputField.dispatchEvent(new InputEvent('change'));
    }

    decrementEvent(e)
    {
        e.preventDefault();

        if(!this.inputField){
            return;
        }
      
        this.value = parseInt(this.inputField.value);

        if(this.options.min > 0 && (this.value - 1) < this.options.min){
            this.value = this.options.min;
        }else{
            this.value--;
        }

        if(this.value < 1){
            this.value = 1;
        }

        this.inputField.value = this.value;
        
        this.inputField.dispatchEvent(new InputEvent('change'));
    }
}

customElements.define('product-quantity', ProductQuantity);